// export const baseHost = 'http://192.168.0.135:9501/hyows';
// export const imgHost = 'http://192.168.0.135:8083/ymg/';

export const baseHost = 'http://www.hyinfo-tec.com/hyows';
export const imgHost = 'https://images.hyicloud.com/hyos/ymg/';
